import {React,Component} from "react";
import ImgsViewer from "react-images-viewer";

export default class ImageViwer extends Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <ImgsViewer
        imgs={this.props.imgs}
        currImg={this.props.currImg}
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        onClickPrev={this.props.onClickPrev}
        onClickNext={this.props.onClickNext}
        showThumbnails={true}
        backdropCloseable={true}
        onClickThumbnail={this.props.onClickThumbnail}
      />
    );
  }
}